import adminAPI from "./admin";
import authAPI from "./auth";
import statsAPI from "./stats";
import filesAPI, { FILES_API } from "./files";
import { accessToken, sessionToken } from "./init";

export { adminAPI, filesAPI, authAPI, accessToken, sessionToken, statsAPI };

// быстрое присваивание результат в указанный сеттер данных
export const setSuccess = (setData) => ({
  onSuccess(body) {
    setData(body);
  },
});

/** ссылка для файлов */
export function fileUrl(fileId, type = "stream") {
  return `${FILES_API}/file_${fileId}/${type}`;
}
